module.exports = __webpack_public_path__ + "img/046-flag.647b0946.svg";